import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { TranslateModule } from '@ngx-translate/core';

import { PlayDialogComponent } from '@common/dialogs/play-dialog/play-dialog.component';
import { SpinnerDialogComponent } from '@common/dialogs/spinner-dialog/spinner-dialog.component';
import { ConfirmationDialogComponent } from '@common/dialogs/confirmation-dialog/confirmation-dialog.component';
import { MessageDialogComponent } from '@common/dialogs/message-dialog/message-dialog.component';
import { ItemSelectionDialogComponent } from '@common/dialogs/item-selection-dialog/item-selection-dialog.component';
import { ImageSelectionDialogComponent } from '@common/dialogs/image-selection-dialog/image-selection-dialog.component';
import { FolderSelectionDialogComponent } from '@common/dialogs/folder-selection-dialog/folder-selection-dialog.component';
import { PublicLinkDialogComponent } from '@common/dialogs/public-link-dialog/public-link-dialog.component';

import { CustomMaterialModule } from '@common/material.module';
import { CommonDialogsService } from '@common/dialogs/common-dialogs.service';
import { SelectListDialogComponent } from '@common/dialogs/select-list-dialog/select-list-dialog.component';
import { SortItemsDialogComponent } from '@common/dialogs/sort-items-dialog/sort-items-dialog.component';
import { CheckUserDialogComponent } from '@common/dialogs/check-user-dialog/check-user-dialog.component';
import { ChangeUserPwdDialogComponent } from '@common/dialogs/change-user-pwd-dialog/change-user-pwd-dialog.component';

import { ItemTreeModule } from '@components/item-tree/item-tree.module';
import { TabBarModule } from '@components/tab-bar/tab-bar.module';

import { QrCodeModule } from 'ng-qrcode';

@NgModule({
    declarations: [
        FolderSelectionDialogComponent,
        PlayDialogComponent,
        ChangeUserPwdDialogComponent,
        CheckUserDialogComponent,
        MessageDialogComponent,
        ConfirmationDialogComponent,
        PublicLinkDialogComponent,
        SpinnerDialogComponent,
        ItemSelectionDialogComponent,
        ImageSelectionDialogComponent,
        SortItemsDialogComponent,
        SelectListDialogComponent
    ],
    imports: [
        QrCodeModule,
        CommonModule,
        FormsModule,
        CustomMaterialModule,
        DragDropModule,
        ReactiveFormsModule,
        TranslateModule.forChild({
            extend: true
        }),
        ItemTreeModule,
        TabBarModule
    ],
    exports: [
        PlayDialogComponent,
        ChangeUserPwdDialogComponent,
        CheckUserDialogComponent,
        MessageDialogComponent,
        ConfirmationDialogComponent,
        PublicLinkDialogComponent,
        SpinnerDialogComponent,
        CustomMaterialModule,
        ItemSelectionDialogComponent,
        ImageSelectionDialogComponent,
        SortItemsDialogComponent,
        SelectListDialogComponent
    ],
})
export class CommonDialogsModule { }
